import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import React from 'react';
import type { OpeningItemProps } from './OpeningItem.types';
import { NextLink } from '../../../../NextLink';

const PREFIX = 'OpeningItem';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledGrid = styled(Grid)(({ theme }: { theme: Theme }) => ({
  [`&.${classes.root}`]: {
    marginTop: theme.spacing(5),
    padding: theme.spacing(2),
    width: '100%',
    border: '1px solid rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
    textAlign: 'center',
  },
}));

export const OpeningItem: React.FC<OpeningItemProps> = ({ opening }) => {
  return (
    <StyledGrid container alignItems="center" className={classes.root}>
      <Grid item xs={12} md={2}>
        <img
          src={opening?.icon?.url}
          alt={opening?.icon?.name}
          width="120"
          height="120"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography variant="h5">{opening?.title}</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography>{opening?.salary}</Typography>
      </Grid>
      <Grid item xs={12} md={2}>
        <NextLink href={`/careers/${opening?.slug}/`}>
          <Button
            sx={{ py: 1, px: 3, mt: { xs: 3, sm: 0 } }}
            color="secondary"
            variant="outlined">
            Learn More
          </Button>
        </NextLink>
      </Grid>
    </StyledGrid>
  );
};
